<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import MessageList from 'dashboard/components-next/message/MessageList.vue';

const props = defineProps({
  conversationId: { type: [String, Number], required: true },
  accountId: { type: [String, Number], required: true },
});

const store = useStore();
const { t } = useI18n();

const currentUserId = computed(() => store.getters.getCurrentUserID);

const conversation = computed(() =>
  store.getters.getConversationById(Number(props.conversationId))
);

const messages = computed(() => {
  return conversation.value?.messages || [];
});

onMounted(async () => {
  if (!conversation.value) {
    await store.dispatch('getConversation', props.conversationId);
  }
  store.dispatch('fetchPreviousMessages', {
    conversationId: Number(props.conversationId),
    before: null,
  });
});
</script>

<template>
  <div class="flex flex-col h-full">
    <!-- Loading state -->
    <div
      v-if="!conversation"
      class="flex items-center justify-center h-32 text-n-slate-11 text-sm"
    >
      <span class="i-lucide-loader-2 size-4 animate-spin mr-2" />
      {{ t('COPILOT.PANEL.LOADING') }}
    </div>

    <template v-else>
      <!-- Conversation meta -->
      <div class="px-4 py-3 border-b border-n-weak bg-n-solid-2 shrink-0">
        <div class="flex items-center justify-between">
          <p class="text-xs font-medium text-n-slate-12 truncate">
            {{
              conversation.meta?.sender?.name ||
              t('COPILOT.PANEL.UNKNOWN_CONTACT')
            }}
          </p>
          <span
            class="px-2 py-0.5 text-[10px] rounded-full bg-n-slate-3 text-n-slate-11 font-medium"
          >
            {{ conversation.status }}
          </span>
        </div>
        <p v-if="conversation.inbox_id" class="text-xs text-n-slate-9 mt-0.5">
          {{ t('COPILOT.PANEL.INBOX') }} #{{ conversation.inbox_id }}
        </p>
      </div>

      <!-- Messages using the real MessageList component -->
      <div class="flex-1 overflow-y-auto">
        <div
          v-if="messages.length === 0"
          class="flex items-center justify-center h-32 text-xs text-n-slate-9"
        >
          {{ t('COPILOT.PANEL.NO_MESSAGES') }}
        </div>
        <MessageList
          v-else
          :messages="messages"
          :current-user-id="currentUserId"
        />
      </div>
    </template>
  </div>
</template>
